<mat-card class="container" *ngIf="!blindtest" i18n="@@blindtestDetails-loadingBlindtest">Chargement</mat-card>
<mat-card class="container" *ngIf="blindtest">
  <bt-review-widget [bt]="blindtest"></bt-review-widget>
  <button mat-raised-button routerLink="../../dashboard" i18n="@@blindtestDetails-backToDashboard">Retour</button>
</mat-card>
